function CommentButton() {
  return <div></div>;
}

export default CommentButton;
